var React = require('react');

function Slideshow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"key":0},React.createElement("path",{"d":"M16,0C7.2,0,0,7.2,0,16c0,8.8,7.2,16,16,16s16-7.2,16-16C32,7.2,24.8,0,16,0z M16,31C7.7,31,1,24.3,1,16C1,7.7,7.7,1,16,1\r\n\t\t\ts15,6.7,15,15C31,24.3,24.3,31,16,31z"})),React.createElement("g",{"key":1},React.createElement("path",{"d":"M27,22H4l8-10.8l6,6.2l3.1-3L27,22z M6,21h19l-4-5.2l-3,3l-5.9-6.1L6,21z"})),React.createElement("g",{"key":2},React.createElement("path",{"d":"M21,12.5c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S22.4,12.5,21,12.5z M21,8.5c-0.8,0-1.5,0.7-1.5,1.5\r\n\t\t\ts0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S21.8,8.5,21,8.5z"}))]);
}

Slideshow.defaultProps = {"version":"1.1","x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 32 32","style":{"enableBackground":"new 0 0 32 32"},"xmlSpace":"preserve"};

module.exports = Slideshow;

Slideshow.default = Slideshow;
